"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var DismissIcon = function DismissIcon(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("line", {
    x1: "0.75",
    y1: "-0.75",
    x2: "23.3778",
    y2: "-0.75",
    transform: "matrix(-0.69474 0.719261 -0.69474 -0.719261 16.802 0)" // the use of currentColor allows the icon to be visible for Windows high contrast mode users
    ,
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "0.75",
    y1: "-0.75",
    x2: "23.374",
    y2: "-0.75",
    transform: "matrix(0.695891 0.718148 -0.695891 0.718148 0 1.46875)",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }));
};

DismissIcon.displayName = 'CloseIcon';
DismissIcon.propTypes = {
  /** Height of the SVG element. If null, default is auto.  */
  height: _propTypes.default.string,

  /** Width of the SVG element. If null, default is auto.  */
  width: _propTypes.default.string
};
DismissIcon.defaultProps = {
  height: null,
  width: null
};
var _default = DismissIcon;
exports.default = _default;